import { render, staticRenderFns } from "./Profitloss_Result_Profit.vue?vue&type=template&id=c6631c46&"
import script from "./Profitloss_Result_Profit.vue?vue&type=script&lang=js&"
export * from "./Profitloss_Result_Profit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports